import React from 'react'
import styles from './EditMessage.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import { observer } from 'mobx-react'
import { classNames as cn } from 'helpers'

const EditMessage = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore
  console.log(modalValue)
  return (
    <FormField>
      <FormLabel>Редактировать сообшение:</FormLabel>
      <textarea
        placeholder={'Редактировать сообшение'}
        value={modalValue?.text}
        onChange={(e) => changeValues(e.target.value, 'text')}
        className={cn({
          [styles.textarea]: true,
          [styles.error]: check('text') || !modalValue?.text?.trim(),
        })}
      />
    </FormField>
  )
}

export default observer(EditMessage)
